export default {
    active_requirement_orders: "Active requirement orders",
    add_laboratory_service: "Add laboratory service",
    after_finished_fixed: "Upon completion",
    can_have_dental_work: "Can have dental work",
    cannot_change_services_that_already_have_laboratory_services_attached: "You cannot delete services that already have laboratory work associated with them from a work order.",
    carcass: "Frame",
    deleted_from_treatment: "Removed from treatment",
    delivery_date: "Delivery date",
    dental_work: "Dental work",
    do_you_confirm_cancel_laboratory_order: "Are you sure you want to cancel the work order?",
    do_you_confirm_laboratory_order_finish: "Do you confirm that the work has been handed over to the patient? After confirmation, the doctor's salary will be accrued, and changes to this work order will be impossible.",
    do_you_confirm_laboratory_order_finish2: "Do you confirm that the work has been handed over to the patient? ",
    executor: "Executor",
    faintly: "Weak",
    field_is_required: "Field is required",
    fitting_date: "Fitting date",
    full: "Full",
    immediately: "Straightaway",
    in_clinic: "In clinic",
    in_lab: "In laboratory",
    initiated: "Initiated",
    intermediate_part_design: "Intermediate design",
    laboratories: "Laboratories",
    laboratory: "Laboratory",
    laboratory_service: "Laboratory service",
    LaboratoryOrder: "Work order",
    logics_on_laboratory_services_deduction: "Logic for subtracting laboratory work by work order",
    moderately: "Moderately",
    must_have_dental_work: "Must have dental work",
    no_dental_work_needed_for_selected_services: "No dental work needed for selected services",
    no_services: "No services",
    order_number: "Order number",
    paint_restorations: "Stain the restorations",
    panorama: "Panorama",
    pay_all: "Pay all",
    requirement_order: "Requirement - order",
    select_from_price: "Select from price",
    send_to_laboratory_via_messenger: "Send to laboratories via messenger",
    shoulder: "Shoulder",
    simplified: "Simplified",
    total_orders_for_the_amount: "Total orders for the amount",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "When changing the laboratory, all selected services will be removed. Continue?",
    without_attachment_to_tooth: "Without attachment to a tooth"
}
